import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "react-router";

import { router } from "./services/Router";
import { queryClient } from "./lib/queryClient";
import { Theme } from "./styles/theme";

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Theme>
        <RouterProvider router={router} />
        <ReactQueryDevtools initialIsOpen={false} />
      </Theme>
    </QueryClientProvider>
  );
}

export default App;
